const config = ['bureauveritas.com', 'bvna.com'];

const isBvEmail = (email: string = '') => {
  return config.some((x) => email.toLowerCase().search(x) > -1);
};

export default isBvEmail;
